import { useCallback, useState } from 'react';
import { PairingScreen } from './PairingScreen';
import { DisplayScreen } from './DisplayScreen';
import { clearSession, loadSession, saveSession } from './session';
import type { DisplaySession } from './session';

/**
 * The reception display app at /display. No shell, no sign-in, no controls: it shows a pairing code until an admin claims
 * it, keeps the device token across reloads, and returns to the pairing screen when the portal unpairs it (401).
 */
export function DisplayApp() {
  const [session, setSession] = useState<DisplaySession | null>(loadSession);
  const paired = useCallback((s: DisplaySession) => {
    saveSession(s);
    setSession(s);
  }, []);
  const revoked = useCallback(() => {
    clearSession();
    setSession(null);
  }, []);
  return session ? <DisplayScreen key={session.token} session={session} onRevoked={revoked} /> : <PairingScreen onPaired={paired} />;
}
